import React from 'react';

import { useAppContext } from 'src/components/app-context';
import { useCampaignCardContext } from '../../campaign-card-context';

import { NewClickOutButton } from 'src/components/product-card-new/components/new-click-out-button';
import { StoreCountLink } from './store-count-link';

import { StyledFooter } from './styles';

export const CampaignCardFooter = () => {
  const { externalLink, handleClickOut, store } = useCampaignCardContext();

  const { t } = useAppContext();

  return (
    <StyledFooter>
      {store?.featured ? (
        <>
          {externalLink && (
            <NewClickOutButton
              href={externalLink}
              external
              onClick={handleClickOut}
              text={t('product', 'kwlp.visit-shop')}
            />
          )}
          <StoreCountLink />
        </>
      ) : (
        <>
          <NewClickOutButton
            external
            href={null}
            text={t('product', 'kwlp.visit-shop')}
          />
          <StoreCountLink />
        </>
      )}
    </StyledFooter>
  );
};
